$(function () {
  let openFiltersButton = $("#collections-open-filters-button");
  let closeFiltersButton = $("#close-collections-filter-container-button");
  let collectionsFilterContainer = $("#collections-filter-container");
  let collectionsFilterInnerContainer = $("#collections-filter-inner-container");

  openFiltersButton.on("click", () => {
    collectionsFilterContainer.addClass("is-visible");
  });

  closeFiltersButton.on("click", () => {
    collectionsFilterContainer.removeClass("is-visible");
  });

  collectionsFilterContainer.on("click", () => {
    collectionsFilterContainer.removeClass("is-visible");
  });

  collectionsFilterInnerContainer.on("click", (e) => {
    e.stopPropagation();
  });
});
